// termineTag.ts — reine Helfer für den Tag der Dashboard-Termine (T-394).
// Ohne React/DOM, damit per vitest prüfbar.

/**
 * Ganztägige Einträge mit gleichem Titel zusammenfassen — die Liste gehört zu
 * EINEM Tag. Feiertage kommen aus mehreren Kalendern doppelt (T-394,
 * 26.10.2026: Reformationstag und Allerheiligen je zweimal im Board). Der
 * erste Eintrag bleibt, die Reihenfolge auch. Getaktete Termine bleiben
 * unberührt: zwei „Rückruf" um 9 und um 14 Uhr sind zwei Termine.
 */
export function fasseGanztaegigeZusammen<T extends { isAllDay?: boolean; subject?: string | null }>(
    events: T[],
): T[] {
    const gesehen = new Set<string>();
    return events.filter((e) => {
        if (!e.isAllDay) return true;
        const titel = (e.subject ?? "").trim().replace(/\s+/g, " ").toLocaleLowerCase("de-DE");
        if (gesehen.has(titel)) return false;
        gesehen.add(titel);
        return true;
    });
}

/** Überschrift des Tages-Popups: „Samstag, 31. Oktober 2026". */
export function tagUeberschrift(d: Date): string {
    return d.toLocaleDateString("de-DE", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    });
}
